export default {
    state: {
        navlist: [
            {
                title: "首页", 
                to: "home",
            }
        ]
    },
    actions: {
        Setnavlist({commit}, value) {
            commit('Mut_navlist', value)
        },
        removeNavList({state, commit}, res) {
            if (state.navlist.length <= 1) return
            commit('remove_navlist', res)
        },
    },
    mutations: {
        Mut_navlist(state, value) {
            const index = state.navlist.map(it => it.to).indexOf(value.to);
            if(index == '-1') state.navlist.push(value)
        },
        IN_navlist(state, value) {
            if(value) state.navlist = value
        },
        remove_navlist(state, res) {
            const index = state.navlist.map(it => it.to).indexOf(res.value)
            switch (res.state) {
                case 'one':
                    state.navlist.splice(index, 1)
                    break;
                case 'other':
                    state.navlist = state.navlist.filter(it => it.to == res.value)
                    break;
                case 'left':
                    state.navlist = state.navlist.slice(index)
                    break;
                case 'right':
                    state.navlist = state.navlist.slice(0, index + 1)
                    break;
                default:
                    break;
            }
        }
    },
    getters: {
        Getnavlist: state => state.navlist,
    }
}